import { Box, Chip, Grid, Stack } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MyLocationIcon from "@mui/icons-material/MyLocation";

export function Status(props) {
    const { icon, value, label } = props;

    return (
        <Stack direction="row" spacing={1}>
            {icon}
            <strong>{value}</strong>
            <span>{label}</span>
        </Stack>
    );
}

export default function StrategicPlanStatus(props) {
    const { strategicPlanning: plan } = props;
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            color="text.secondary"
        >
            <Grid item>
                status:{" "}
                <Chip
                    size="small"
                    color={plan.lifecycle_status == "active" ? "success" : "default"}
                    label={plan.lifecycle_status}
                />
            </Grid>
            <Grid item>
                <Chip size="small" label={`${plan.timeframe.title} ${plan.start_year} - ${plan.due_year}`} />
            </Grid>
            <Grid item>
                <Status icon={<MyLocationIcon />} label="objective" value={plan.objective_count ?? 0} />
            </Grid>
            <Grid item>
                <Status icon={<FlagIcon />} label="goal" value={plan.goal_count ?? 0} />
            </Grid>
            <Grid item>
                <Status icon={<AssignmentIcon />} label="action plan" value={plan.action_plan_count ?? 0} />
            </Grid>
        </Grid>
    );
}
